// ** Reactstrap Imports
import { Card, CardBody } from "reactstrap";

// ** Third Party Components
import { ArrowRight } from "react-feather";
import { useTranslation } from "react-i18next";

// ** Custom Components
import SkeletonLoading from "@components/skeleton";
import LazyImg from "@components/lazy-load-image";

// ** Styles
import "@styles/base/pages/page-blog.scss";

const FacebookPostsCard = ({ item, loading }) => {
  const { t } = useTranslation();

  return (
    <Card className="mt-3">
      <a target="_blank" href={item.permalink_url}>
        <div className="facebook-card__img-container">
          <LazyImg
            src={item?.attachments[0]?.image.src}
            alt={`${item.story} image`}
            className="img-fluid rounded-top"
          />
        </div>
      </a>
      <CardBody>
        <p
          className={`facebook-title-truncate text-body-heading mb-50 ${
            item.title
              ? item.title.length < 25
                ? "d-flex align-items-center"
                : ""
              : ""
          }`}
        >
          {loading ? <SkeletonLoading height={30} /> : item.story}
        </p>

        <div className="mt-50">
          <small className="blog-content-truncate d-flex align-items-center">
            {loading ? (
              <SkeletonLoading height={25} />
            ) : item.brief?.length >= 50 ? (
              `${item.brief?.substring(0, 50)} ...`
            ) : (
              item.brief
            )}
          </small>
        </div>
        <hr className="my-75" />
        <div className="d-flex justify-content-end align-items-center">
          <a className="fw-bold" target="_blank" href={item.permalink_url}>
            {loading ? (
              <SkeletonLoading height={15} width={75} />
            ) : (
              <>
                {t("read_more")}
                <ArrowRight size={18} className="ms-1" />
              </>
            )}
          </a>
        </div>
      </CardBody>
    </Card>
  );
};

export default FacebookPostsCard;
